import React, { useEffect } from "react";
import { usePageSettings } from "../contexts/PageSettingsContext";

// Import translation files for each language
import enTranslations from "../locales/en/translations.json";
import esTranslations from "../locales/es/translations.json";
import Layout from "../components/ui/layout/layout";
import BaremetalPageTemplate from "./services/BaremetalPageTemplate";
import StoragePageTemplate from "./services/StoragePageTemplate";
import SeoHeader from "../components/ui/layout/SeoHeader";
import VpsPageTemplate from "./services/VpsPageTemplate";
import UltraproxyPageTemplate from "./services/UltraproxyPageTemplate";
import ColocationPageTemplate from "./services/ColocationPageTemplate";
import BgpPageTemplate from "./services/BgpPageTemplate";
import SmartpbxPageTemplate from "./services/SmartpbxPageTemplate";
import WebHostingPageTemplate from "./services/WebHostingPageTemplate";
import IpTransitPageTemplate from "./services/IpTransitPageTemplate";

//ServicePageTemplate will determine the corresponding template based on the pageContext type prop received via gatsby-node.js (createPages)
const ServicePageTemplate = ({ pageContext, serverData }) => {
	const { type, language } = pageContext;
	const { loadPageTranslations, loadPageSettingsContext, changeLanguage } =
		usePageSettings();

	// Select the translation file based on the current language
	let translations;
	switch (language) {
		case "en":
			translations = enTranslations;
			break;
		case "es":
			translations = esTranslations;
			break;
		default:
			translations = enTranslations; // Default to English
	}

	//Set up the Frontend context with the pageContext passed down from gatsby-node.js
	useEffect(() => {
		loadPageSettingsContext(pageContext);
		loadPageTranslations(translations);
		changeLanguage(language);
	}, []);

	//TODO: Make a cleaner return method
	return (
		<Layout pageContext={pageContext}>
			{type === "baremetal" && (
				<BaremetalPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "storage" && (
				<StoragePageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "vps" && (
				<VpsPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "ultraproxy" && (
				<UltraproxyPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "colocation" && (
				<ColocationPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "bgp-peering" && (
				<BgpPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "smartpbx" && (
				<SmartpbxPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "web-hosting" && (
				<WebHostingPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
			{type === "ip-transit" && (
				<IpTransitPageTemplate
					pageContext={pageContext}
					translations={translations}
				/>
			)}
		</Layout>
	);
};

export const Head = ({ pageContext }) => (
	<SeoHeader pageContext={pageContext} />
);

export default ServicePageTemplate;

export async function getServerData() {
	return {
		props: {},
	};
}
